import web3Dapp from './web3_dapp';
const {abi, address} = require('./artburn_client');

export default new web3Dapp.eth.Contract(abi, address);